import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f33ae8c&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1f33ae8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f33ae8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f33ae8c')) {
      api.createRecord('1f33ae8c', component.options)
    } else {
      api.reload('1f33ae8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f33ae8c&scoped=true&", function () {
      api.rerender('1f33ae8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiscountCoupon/index.vue"
export default component.exports